import React from 'react';
import {
  Box,
  Typography,
  // Grid,
  // Card,
  // CardContent,
  Paper,
} from '@mui/material';
// import {
//   Dashboard,
//   School,
//   Person,
//   TrendingUp,
// } from '@mui/icons-material';
import { useAuth } from '@/hooks';

export const DashboardPage: React.FC = () => {
  const { user } = useAuth();

  // const statsCards = [
  //   {
  //     title: 'Total Students',
  //     value: '1,234',
  //     icon: <School />,
  //     color: '#1976d2',
  //   },
  //   {
  //     title: 'Active Staff',
  //     value: '89',
  //     icon: <Person />,
  //     color: '#2e7d32',
  //   },
  //   {
  //     title: 'Courses',
  //     value: '45',
  //     icon: <Dashboard />,
  //     color: '#ed6c02',
  //   },
  //   {
  //     title: 'Growth Rate',
  //     value: '+12%',
  //     icon: <TrendingUp />,
  //     color: '#d32f2f',
  //   },
  // ];

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Welcome back, {user?.name}!
      </Typography>
      
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        Here's what's happening at your Work place today.
      </Typography>
{/* 
      <Grid container spacing={3}>
        {statsCards.map((card, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
            <Card
              sx={{
                height: '100%',
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                  boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px!important'
                  // transform: 'translateY(-4px)',

                  // boxShadow: '4px !important',
                },
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box>
                    <Typography
                      variant="h4"
                      component="div"
                      sx={{ fontWeight: 'bold', mb: 1 }}
                    >
                      {card.value}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {card.title}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: 56,
                      height: 56,
                      borderRadius: '50%',
                      bgcolor: card.color,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                    }}
                  >
                    {card.icon}
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid> */}

      <Box sx={{ mt: 4 }}>
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Recent Activity
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Your dashboard is ready! This is where you'll see the latest office activities,
            announcements, and important updates.
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
};